import Auth0Lock from 'auth0-lock';
import * as authHelper from '../utils/AuthHelper'
import { browserHistory } from 'react-router'

import { hideModal } from './ModalAction'

export const SHOW_LOCK = 'SHOW_LOCK';

export const LOAD_LOGIN = 'LOAD_LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGOUT = 'LOG_OUT';

const lock = new Auth0Lock(__AUTH0_CLIENT_ID__, __AUTH0_DOMAIN__, {
  closable: false,
  auth: {
    redirectUrl: `${window.location.origin}/#login`,
    responseType: 'token id_token'
  },
  theme: {
    logo: 'favicon.ico'
  },
  languageDictionary: {
    title: "ShopCollect Admin"
  }
});

function loadLogin(profile, token) {
  return {
    type: LOAD_LOGIN,
    profile,
    token
  }
}

function showLock() {

  lock.show();

  return {
    type: SHOW_LOCK
  }
}

function lockSuccess(profile, token) {
  lock.hide();

  return {
    type: LOGIN_SUCCESS,
    token
  }
}

function lockError(err) {
  return {
    type: LOGIN_ERROR,
    err
  }
}

function logoutAction(err) {
  return {
    type: LOGOUT
  }
}

export function loadLoginInfo() {
  // display lock widget
  return dispatch => {
    // if(authHelper.loggedIn()){

      dispatch(loadLogin(authHelper.getProfile(), authHelper.getToken()))
    // }
  }
}

export function login() {

  // display lock widget
  return dispatch => {

      dispatch(showLock())
  }
}

export function logout() {

  return dispatch => {
    // Clear user token and profile data from local storage

    authHelper.logout();

    dispatch(logoutAction())

    browserHistory.push('/#home');

    dispatch(showLock())

  }
}

// Listen to authenticated event and get the profile of the user
export function doAuthentication() {
    return dispatch => {
      lock.on("authenticated", function(authResult) {

        lock.getUserInfo(authResult.accessToken, function(error, profile) {

          if (error) {
            // handle error
            return dispatch(lockError(error))
          }

          authHelper.setProfile(profile)
          dispatch(loadLogin(profile, authHelper.getToken()))

        });

        authHelper.setToken(authResult.idToken);
        return dispatch(lockSuccess(authResult.idToken))
      });
    }
}



// WEBPACK FOOTER //
// ./src/actions/LoginAction.js